import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Popover2, Fragment, pluralize} from '@api'
import { Button, Menu, MenuItem } from '@blueprintjs/core'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {PdfArtifactDropdownMenu} from '@modules/pdf/serverRenderedPDF/components/PdfArtifactDropdownMenu'
import {StoresInstance} from '@stores'
import * as css from './PDFArtifactDropdown.css'

/// region Store

export class PDFArtifactDropdownStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  get container() { return this.stores.cloudPDF.component }
}

export const PdfArtifactDropdownStoreContext = React.createContext<PDFArtifactDropdownStore>(null)
export const usePdfArtifactDropdownStore = () => React.useContext(PdfArtifactDropdownStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const QUERY_KEY_PDF_ARTIFACTS = 'pdfArtifacts'
export const PDFArtifactDropdown = observer<MyProps>(function PDFArtifactDropdown({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new PDFArtifactDropdownStore(stores, obsProps)),
    {container} = store

  // console.log({
  //   data,
  //   error,
  //   fetchNextPage,
  //   hasNextPage,
  //   isFetching,
  //   isFetchingNextPage,
  //   status
  // })
  useEffect(() => store.registerEffects(), [])

  return (
    <PdfArtifactDropdownStoreContext.Provider value={store}>
      <Popover2 className={classNames(css.root, className)}
                interactionKind='hover'
                placement='bottom-start'
                content={<PdfArtifactDropdownMenu />}
      >
        <Button text={!container?.selectedPdf ? 'Select PDF...' : (container.selectedPdf.entry.filename ?? container.selectedPdf.entry.s3Key)} rightIcon='caret-down' />
      </Popover2>
    </PdfArtifactDropdownStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/components/PDFArtifactDropdown.tsx